import React, { useState, useEffect } from 'react'
import "./RenameReport.css"
import notes from "../../assets/images/svg/notes.svg"
import Cookies from 'js-cookie';
import axios from 'axios';
import { ConfirmAdd } from '../../Components';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import edit from "../../assets/images/svg/edit.svg"

import SubModal from '@mui/material/Modal';
import Box from '@mui/material/Box';

const RenameReport = ({ url, name, cancelBtn, onSuccess, topic, note, filters, translations }) => {

    const [remportName, setReportName] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [query, setQuery] = useState({});


    const [subPopup, setSubPopup] = useState(false);
    const [messagePopup, setMessagePopup] = useState("") 

    const handleCloseSubPopup = () => {
        setSubPopup(false);
    };
  

    useEffect(() => {
        const updatedQuery = {};
        // let withPagination = 0;

        filters.forEach(filter => {
            updatedQuery[filter.field] = filter.value;
        });

        // if (updatedQuery['start'] && updatedQuery['limit']) {
        //     withPagination = 1;
        // }

        // updatedQuery['with_pagination'] = withPagination;

        setQuery(updatedQuery);

    }, [filters]);





    const confirmRename = async () => {

        const apiUrl = `${url}/api/method/projectx.projectx.doctype.law_report.law_report.law_report`;
        const data = {
            "name": name,
            "report_name": remportName,
            "topic": topic,
            "note": note,
            // "query": query
        };

        try {
            const apiKey = Cookies.get('api_key');
            const apiSecret = Cookies.get('api_secret');
            const response = await axios.put(apiUrl, data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `token ${apiKey}:${apiSecret}`,
                },
            });
            if (response.data && response.data.status_code === 200) {
                toast.success(translations?.message?.successRenameFolder ? translations.message.successRenameFolder : 'Folder rename successfully.');

                onSuccess();
            } else {
                toast.error(translations?.message?.failedRenameFolder ? translations.message.failedRenameFolder : 'Failed to rename the folder.');
            }

            if (response?.data?.status_code === 202) {
                setSubPopup(true);
            }
        } catch (error) {
            if (error?.response?.data?.status_code === 202) {
                setSubPopup(true);
                setMessagePopup(error?.response?.data?.message)
            }
            toast.error(translations?.message?.failedRenameFolder ? translations.message.failedRenameFolder : 'Failed to rename the folder.');
        }
        setShowPopup(false);
        cancelBtn();
    };
    const cancelRename = () => {
        setShowPopup(false);
    };
    const handleRename = () => {
        if (remportName.trim() === '') {
            setErrorMessage(translations?.message?.pleaseAddNewFolderName ? translations.message.pleaseAddNewFolderName : 'Please Add a New Folder Name');
            setShowPopup(false);
        }
        else {
            setShowPopup(true);
        }

    };

    return (
        <div className='add-report-container'>
            <div className='add-report-header'>
                <div className='d-flex align-items-center'>
                    <img className='add-report-img' src={notes} />
                    <h1 className='add-report-title'>
                        {translations?.message?.renameFolder ? translations.message.renameFolder : "Rename the folder"}
                    </h1>
                </div>

            </div>
            <div className='add-report-inputs'>
                <input type='text' className='add-report-text' placeholder={translations?.message?.yourFolderName ? translations.message.yourFolderName : 'Your folder name'} onChange={(event) => setReportName(event.target.value)} />

                <button className='add-report-button' onClick={() => handleRename()}>

                    {translations?.message?.rename ? translations.message.rename : 'Rename'}
                </button>
            </div>
            {errorMessage && (
                <div className="popup-error">
                    <p>{errorMessage}</p>
                </div>
            )}
            <div className='add-report-btns'>
                <button className='add-report-cancle' onClick={cancelBtn}>{translations?.message?.cancel ? translations.message.cancel : "Cancel"}</button>
            </div>
            <Modal
                isOpen={showPopup}
                onRequestClose={cancelRename}
                contentLabel="Confirmation Popup"
            >
                <ConfirmAdd
                    para={translations?.message?.areSureRename ? translations.message.areSureRename : "Are you sure you want to rename this?"}
                    cancleAdd={cancelRename}
                    confirmAdd={confirmRename}
                    addPara={translations?.message?.yesSure ? translations.message.yesSure : "Yes, Sure"}
                    src={edit}
                    translations={translations}
                />
            </Modal>

            <SubModal
                open={subPopup}
                onClose={handleCloseSubPopup}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
                >
                <Box className="subpopup-container">
                    <p className='subpopup-text'>
                    {
                        messagePopup ? messagePopup : "your subscription has expired"
                    }
                    </p>
                    <a className='subpopup-link' href='/pricing'>Go To Pricing</a>
                </Box>
            </SubModal>

        </div>
    )
}

export default RenameReport